import type { Dispatch, SetStateAction } from 'react';
import { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

interface PriceProps {
  price?: string;
  priceWidth?: number;
  setPriceWidth?: Dispatch<SetStateAction<number>>;
}

export function Price({
  price,
  priceWidth = 0,
  setPriceWidth,
  ...restProps
}: PriceProps) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (ref) {
      if (setPriceWidth && priceWidth !== ref?.current?.clientWidth) {
        setPriceWidth(ref?.current?.clientWidth || 0);
      }
    }
  });

  if (!price) return null;

  return (
    <PriceComponent {...restProps} ref={ref}>
      {price}
    </PriceComponent>
  );
}

export const PriceComponent = styled.div`
  font-size: ${({
    theme: {
      itemPriceFontSize: { fontSize }
    }
  }) => fontSize}px;
  line-height: 1.5;
  text-align: right;
  color: #111111;
`;
